import functions from "./functions.js";

$(function () {

    const $form = $('.booking-form');
    const form = $form[0];

    $('.btn-checkout').on('click', e => {
        e.preventDefault();
        $('#booking-tab').tab('show');
    });

    $('.btn-back-cart').on('click', e => {
        e.preventDefault();
        $('#cart-tab').tab('show');
    });

    $('button.empty-cart').on('click', e => {
        e.preventDefault();
        functions.setCookie('cart_data', JSON.stringify([]));
        //functions.setUrlData({'cart': JSON.stringify([]) }, false);
        location.reload();
        $('.cart-items-count').text(JSON.parse(functions.getCookie('cart_data')).length);
    });

    $('button.remove-from-cart').on('click', e => {
        e.preventDefault();
        const $target = $(e.currentTarget);
        const unitId = $target.attr('data-unitid');
        const dateFrom = $target.attr('data-dateFrom');
        const dateTo = $target.attr('data-dateTo');
        const guests = $target.attr('data-guests');
        
        let cartData = functions.getCookie('cart_data');
        cartData = JSON.parse(cartData);
        
        let i = 0;

        cartData.forEach((item, index) => {
            if(i == 0 && unitId == item.unitId && dateFrom == item.dateFrom && dateTo == item.dateTo && guests == item.guests) {
                cartData.splice(index, 1);
                i = 1;
            }
        });

        functions.setCookie('cart_data', JSON.stringify(cartData));
        location.reload();
        //functions.setUrlData({'cart': JSON.stringify(cartData) }, false);

        $('.cart-items-count').text(JSON.parse(functions.getCookie('cart_data')).length);
    });

    if (!form) {
        return;
    }

    const booking = {
        $form: null,
        $payment: null,
        $calculation: null,
        calc: [],
        persons: null,
        promoDiscount: null,
        totalAmount: null,

        init() {
            booking.$form = $(".booking-form");
            booking.$calculation = $(".table-calculation");
            booking.promoDiscountItem = booking.$calculation.data('promodiscountitem');
            booking.$payment = $(".payment-details");
            booking.$calculationFlight = booking.$calculation.find("*[data-calcFlight]");
            booking.params = {};


            booking.$calculation.find("*[data-calc]").each(function (index) {
                let item = JSON.parse($(this).attr('data-calc'));
                item.inCalc = item.isOptional ? 0 : 1;
                booking.calc.push(item);
            });

            booking.$calculation.find('input[type="checkbox"]').change(function (e) {
                let $row = $(this).closest('tr');
                let $quantity = $row.find('select.quantity');
                let value = +$quantity.val();
                let checked = $(this).is(':checked') ? 1 : 0;

                if (checked && !value) {
                    $quantity.prop('value', 1);
                } else if (!checked && value) {
                    $quantity.prop('value', 0);
                }

                booking.calculate($(this));
            });



            booking.$calculation.find('select.quantity').change(function (e) {
                let $row = $(this).closest('tr');
                let $checkbox = $row.find('input[type="checkbox"]');
                let value = +$(this).val();

                if (value && !$checkbox.is(':checked')) {
                    $checkbox.prop('checked', true);
                } else if (!value && $checkbox.is(':checked')) {
                    $checkbox.prop('checked', false);
                }

                booking.calculate($(this));
            });

            booking.total();


            if (booking.$payment.length) {
                booking.params.paymentType = 'bankTransfer';
                /*booking.$payment.find('input[name="paymentType"]').change(function (e) {
                    booking.params.paymentType = booking.$payment.find('input[name="paymentType"]:checked').val();
                });*/
            }

            booking.$form.on('submit', e => {
               booking.submit();
            });

            /*$(".btn-promo-code").on('click', e => {
                let params = {};
                params['language'] = functions.getLang();
                params['promoCode'] = $("input[name='promoCode']").val();

                $.post('/services/promoCode/', params).then(response => {
                    $(".promo-code-output").removeClass('d-none').html(response.data);
                    if (response.status == true) {
                        $(".btn-promo-code").attr('disabled', true);
                        let discountPercent = response.percent;
                        let discountAmount = -1 * (booking.totalAmount * (discountPercent/100));

                        booking.promoDiscountItem.priceIn = discountAmount;
                        booking.promoDiscountItem.price = discountAmount;
                        booking.promoDiscountItem.totalIn = discountAmount;
                        booking.promoDiscountItem.total = discountAmount;
                        booking.promoDiscountItem.noteHidden = params['promoCode'];
                        booking.promoDiscountItem.skipCalculate = true;

                        $('<tr class="promoDiscountItem" data-calc=\'' + JSON.stringify(booking.promoDiscountItem) + '\'>\n' +
                            '        <td class="px-3">\n' +
                            '            <div class="custom-control custom-checkbox">\n' +
                            '                <input type="checkbox" class="custom-control-input" id="' + booking.promoDiscountItem.id + '" name="' + booking.promoDiscountItem.id + '" checked="" disabled="">\n' +
                            '                <label class="custom-control-label" for="' + booking.promoDiscountItem.id + '"></label>\n' +
                            '            </div>\n' +
                            '        </td>\n' +
                            '        <td class="px-3">\n' +
                            '            <div>\n' +
                            '                ' + booking.promoDiscountItem.itemDefinitionId.text + '\n' +
                            '            </div>\n' +
                            '        </td>\n' +
                            '        <td class="px-3 text-center text-nowrap d-none d-lg-table-cell">\n' +
                            '                            1\n' +
                            '                    </td>\n' +
                            '        <td class="px-3 text-right text-nowrap d-none d-lg-table-cell">\n' +
                            '            ' + functions.formatMoney(discountAmount, 2, ',', '.') + ' €\n' +
                            '        </td>\n' +
                            '        <td class="px-3 text-right text-nowrap d-none d-lg-table-cell">\n' +
                            '            <span class="item-total-amount">' + functions.formatMoney(discountAmount, 2, ',', '.') + '</span> €\n' +
                            '        </td>\n' +
                            '    </tr>').insertBefore(".total-row");

                        booking.calc.push(booking.promoDiscountItem);
                        booking.calculate($(".promoDiscountItem").find("input[type='checkbox']"));
                    }
                });
            });*/

        },
        submit() {

            $.each(booking.calc, function(key, item) {
                if ( ! item.inCalc) {
                    delete booking.calc[key];
                } else if (item.itemDefinitionId.categoryId.key == 'baseRate') {
                    let $guestsPerProduct = $("[data-guests-parentId='" + item.parentId + "']");
                    let guests = [];

                    if ($guestsPerProduct.length) {
                        $guestsPerProduct.find('[data-guests]').each(function (index) {
                            let g = +$(this).data('guests');
                            guests[index] = {
                                firstName : $(this).find("input[name='firstName" + g + "']").val(),
                                lastName : $(this).find("input[name='lastName" + g + "']").val(),
                                age : $(this).find("input[name='age" + g + "']").val()
                            };
                        });
                        booking.calc[key].guestsData = guests;
                    }
                }
            });

            booking.params.calc = JSON.stringify(booking.calc);
            booking.params.requestId = Math.floor(Math.random() * ((9999999 - 1000000) + 1) + 1000000);

            $.each(booking.params, function (key, param) {
                $('<input>').attr({
                    type: 'hidden',
                    name: key,
                    value: param
                }).appendTo(booking.$form);
            });

        },
        calculate($elem) {
            let $row = $elem.closest('tr');

            let $checkbox = $row.find('input[type="checkbox"]');
            let checked = $checkbox.is(':checked') ? 1 : 0;
            let id = $checkbox.attr('id');

            let $quantity = $row.find('select.quantity');
            let quantity = null;

            if ($quantity.length) {
                quantity = +$quantity.val();
            }



            $.each(booking.calc, function (key, calc) {
                if (calc.id == id) {

                    if (quantity == null) {
                        quantity = booking.calc[key].quantity;
                    }

                    booking.calc[key].inCalc = checked;
                    booking.calc[key].quantity = (quantity || 1);
                    booking.calc[key].total = booking.itemTotal(booking.calc[key]);
                    booking.calc[key].totalConverted = booking.itemTotalConverted(booking.calc[key]);

                    $row.find('.item-total-amount').html(functions.formatMoney(booking.calc[key].total, 2, ',', '.'));
                    $row.find('.item-total-amount-converted').html(functions.formatMoney(booking.calc[key].totalConverted, 2, ',', '.'));
                }
            });

            booking.total();
        },
        itemTotal(item) {
            let itemTotal = 0.00;

            if (item.paymentTypeId.key) {

                if ($.inArray(item.paymentTypeId.key, ['perPerson', 'perPersonPerDay', 'perPersonPerWeek']) > -1) {
                    itemTotal = +item.quantity * +item.price;
                } else {
                    itemTotal = +item.price;
                }
            } else {
                itemTotal = +item.quantity * +item.price;
            }

            return itemTotal;
        },
        itemTotalConverted(item) {
            let itemTotal = 0.00;

            if (item.paymentTypeId.key) {

                if ($.inArray(item.paymentTypeId.key, ['perPerson', 'perPersonPerDay', 'perPersonPerWeek']) > -1) {
                    itemTotal = +item.quantity * +item.priceConverted;
                } else {
                    itemTotal = +item.priceConverted;
                }
            } else {
                itemTotal = +item.quantity * +item.priceConverted;
            }

            return itemTotal;
        },
        total() {
            booking.totalAmount = 0.00;
            booking.totalAmountConverted = 0.00;

            let calculations = [];
            $.each(booking.calc, function (key, calc) {
                if (!calc.onSpot && calc.inCalc) {

                    let totalAmount = booking.itemTotal(calc);
                    let totalAmountConverted = booking.itemTotalConverted(calc);

                    if (!calculations[calc.calcId]) {
                        calculations[calc.calcId] = [];
                    }

                    calculations[calc.calcId].push({totalAmount : totalAmount, totalAmountConverted : totalAmountConverted});

                    booking.totalAmount += totalAmount;
                    booking.totalAmountConverted += totalAmountConverted;
                }
            });


            Object.keys(calculations).forEach(key => {

                let items = calculations[key];
                let $calc = $('.calc-' + key);

                let totalAmount = 0;
                let totalAmountConverted = 0;

                $.each(items, function (key2, item) {
                    totalAmount += item.totalAmount;
                    totalAmountConverted += item.totalAmountConverted;
                });

                $calc.find('.calc-total-amount').html(functions.formatMoney(totalAmount, 2, ',', '.'));
                $calc.find('.calc-total-amount-converted').html(functions.formatMoney(totalAmountConverted, 2, ',', '.'));
            });

            booking.$calculation.find('.total-amount').html(functions.formatMoney(booking.totalAmount, 2, ',', '.'));
            booking.$calculation.find('.total-amount-converted').html(functions.formatMoney(booking.totalAmountConverted, 2, ',', '.'));

            $('.total-amount').html(functions.formatMoney(booking.totalAmount, 2, ',', '.'));
            $('.total-amount-converted').html(functions.formatMoney(booking.totalAmountConverted, 2, ',', '.'));

            const advancePaymentPercent = $('[data-advancePaymentPercent]').attr('data-advancepaymentpercent');
            const advance = booking.totalAmount * (advancePaymentPercent / 100);
            const rest = booking.totalAmount - advance;

            $('.advance').html(functions.formatMoney(advance, 2, ',', '.'));
            $('.rest').html(functions.formatMoney(rest, 2, ',', '.'));

            const advanceConverted = booking.totalAmountConverted * (advancePaymentPercent / 100);
            const restConverted = booking.totalAmountConverted - advanceConverted;

            $('.advance-converted').html(functions.formatMoney(advanceConverted, 2, ',', '.'));
            $('.rest-converted').html(functions.formatMoney(restConverted, 2, ',', '.'));

        }
    }

    booking.init();
});